import { Method, AxiosError } from 'axios';
import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { useApiContext } from 'src/compass/site/providers';
import { onErrorDefaultHandler } from 'src/compass/shared/util/onErrorHandlers';

interface IUseAPI {
  method: Method;
  url: string;
  data?: Object;
  staleTime?: number;
  gcTime?: number;
  enabled?: boolean;
  onSuccess?: Function;
  onError?: (error: AxiosError<any>) => any;
  queryKey?: string[];
  params?: Record<string, any>;
  refetchInterval?: number | false;
  placeholderData?: (previousData: any) => any;
}

export function useAPI({
  method,
  url,
  data = {},
  staleTime = 0,
  gcTime,
  enabled = true,
  onSuccess,
  onError = onErrorDefaultHandler,
  queryKey,
  params,
  refetchInterval,
  placeholderData,
}: IUseAPI): UseQueryResult<any, AxiosError> {
  const { api } = useApiContext();

  return useQuery({
    queryKey: queryKey || [url, { data, params }],
    queryFn: async () => {
      try {
        const response = await api({ method, url, data, params });
        if (onSuccess) return onSuccess(response.data);
        return response.data;
      } catch (error) {
        return Promise.reject(onError(error));
      }
    },
    staleTime,
    gcTime,
    enabled,
    refetchInterval,
    placeholderData, 
  });
}
